import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "ID")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Icon")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Label")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Width")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Height")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Type")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Text")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Placeholder")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Src")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Controls")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Autoplay")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Loop")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Muted")
], -1)
const _hoisted_18 = {
  key: 1,
  style: {"padding":"20px","text-align":"center"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_AssetManagerComponent = _resolveComponent("AssetManagerComponent")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.containerRef)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_a_row, { gutter: 10 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _createVNode(_component_a_input, {
                    value: _ctx.containerRef.attributes.id,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.containerRef.attributes.id) = $event)),
                    placeholder: "ID",
                    onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updatePage()))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              (
					_ctx.containerRef.attributes.height ||
						_ctx.containerRef.attributes.height == ''
				)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 0,
                    span: 12
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { gutter: 10 }, {
            default: _withCtx(() => [
              (
					_ctx.containerRef.attributes.icon ||
						_ctx.containerRef.attributes.icon == ''
				)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 0,
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3,
                      _createVNode(_component_a_input, {
                        value: _ctx.containerRef.attributes.icon,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.containerRef.attributes.icon) = $event)),
                        placeholder: "Icon",
                        onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updatePage()))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { gutter: 10 }, {
            default: _withCtx(() => [
              (
					_ctx.containerRef.attributes.label ||
						_ctx.containerRef.attributes.label == ''
				)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 0,
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4,
                      _createVNode(_component_a_input, {
                        value: _ctx.containerRef.attributes.label,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.containerRef.attributes.label) = $event)),
                        placeholder: "Label",
                        onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updatePage()))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { gutter: 10 }, {
            default: _withCtx(() => [
              (
					_ctx.containerRef.attributes.width ||
						_ctx.containerRef.attributes.width == ''
				)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 0,
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5,
                      _createVNode(_component_a_input, {
                        value: _ctx.containerRef.attributes.width,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.containerRef.attributes.width) = $event)),
                        placeholder: "Width",
                        onBlur: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updatePage()))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (
					_ctx.containerRef.attributes.height ||
						_ctx.containerRef.attributes.height == ''
				)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 1,
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6,
                      _createVNode(_component_a_input, {
                        value: _ctx.containerRef.attributes.height,
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.containerRef.attributes.height) = $event)),
                        placeholder: "Height",
                        onBlur: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updatePage()))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { gutter: 10 }, {
            default: _withCtx(() => [
              (
					_ctx.containerRef.attributes.type ||
						_ctx.containerRef.attributes.type == ''
				)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 0,
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7,
                      _createVNode(_component_a_input, {
                        value: _ctx.containerRef.attributes.type,
                        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.containerRef.attributes.type) = $event)),
                        placeholder: "Type",
                        onBlur: _cache[11] || (_cache[11] = ($event: any) => (_ctx.updatePage()))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (
					_ctx.containerRef.attributes.text ||
						_ctx.containerRef.attributes.text == ''
				)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 1,
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8,
                      _createVNode(_component_a_input, {
                        value: _ctx.containerRef.attributes.text,
                        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.containerRef.attributes.text) = $event)),
                        placeholder: "Text",
                        onBlur: _cache[13] || (_cache[13] = ($event: any) => (_ctx.updatePage()))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { gutter: 10 }, {
            default: _withCtx(() => [
              (
					_ctx.containerRef.attributes.placeholder ||
						_ctx.containerRef.attributes.placeholder == ''
				)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 0,
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9,
                      _createVNode(_component_a_input, {
                        value: _ctx.containerRef.attributes.placeholder,
                        "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.containerRef.attributes.placeholder) = $event)),
                        placeholder: "Placeholder text",
                        onBlur: _cache[15] || (_cache[15] = ($event: any) => (_ctx.updatePage()))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (
					_ctx.containerRef.attributes.src ||
						_ctx.containerRef.attributes.src == ''
				)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 1,
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10,
                      _hoisted_11,
                      (_ctx.containerRef.type == 'IFrame')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createVNode(_component_a_input, {
                              value: _ctx.containerRef.attributes.src,
                              "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.containerRef.attributes.src) = $event)),
                              placeholder: "src",
                              onBlur: _cache[17] || (_cache[17] = ($event: any) => (_ctx.updatePage()))
                            }, null, 8, ["value"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.containerRef.type == 'Video')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            (!_ctx.containerRef.attributes.src)
                              ? (_openBlock(), _createBlock(_component_a_button, {
                                  key: 0,
                                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.chooseAsset()))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Choose video")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.containerRef.attributes.src)
                              ? (_openBlock(), _createBlock(_component_a_input, {
                                  key: 1,
                                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.chooseAsset())),
                                  value: _ctx.containerRef.attributes.src,
                                  "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.containerRef.attributes.src) = $event)),
                                  placeholder: "src",
                                  onBlur: _cache[21] || (_cache[21] = ($event: any) => (_ctx.updatePage()))
                                }, null, 8, ["value"]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { gutter: 10 }, {
            default: _withCtx(() => [
              (_ctx.containerRef.attributes.controls)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 0,
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14,
                      _createVNode(_component_a_input, {
                        value: _ctx.containerRef.attributes.controls,
                        "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.containerRef.attributes.controls) = $event)),
                        placeholder: "Controls",
                        onBlur: _cache[23] || (_cache[23] = ($event: any) => (_ctx.updatePage()))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.containerRef.attributes.autoplay)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 1,
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15,
                      _createVNode(_component_a_input, {
                        value: _ctx.containerRef.attributes.autoplay,
                        "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.containerRef.attributes.autoplay) = $event)),
                        placeholder: "Autoplay",
                        onBlur: _cache[25] || (_cache[25] = ($event: any) => (_ctx.updatePage()))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { gutter: 10 }, {
            default: _withCtx(() => [
              (_ctx.containerRef.attributes.loop)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 0,
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16,
                      _createVNode(_component_a_input, {
                        value: _ctx.containerRef.attributes.loop,
                        "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.containerRef.attributes.loop) = $event)),
                        placeholder: "Loop",
                        onBlur: _cache[27] || (_cache[27] = ($event: any) => (_ctx.updatePage()))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.containerRef.attributes.muted)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 1,
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_17,
                      _createVNode(_component_a_input, {
                        value: _ctx.containerRef.attributes.muted,
                        "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.containerRef.attributes.muted) = $event)),
                        placeholder: "Muted",
                        onBlur: _cache[29] || (_cache[29] = ($event: any) => (_ctx.updatePage()))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (!_ctx.containerRef?.attributes || !_ctx.containerRef)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, " Please select an element or container "))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      footer: null,
      visible: _ctx.showModal,
      title: 'Assets',
      onCancel: _cache[31] || (_cache[31] = ($event: any) => (_ctx.showModal = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AssetManagerComponent, {
          onSetAsset: _cache[30] || (_cache[30] = ($event: any) => (_ctx.setAsset($event)))
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}